import React from 'react';
import {
  useElement,
} from '@udecode/plate-common';
import clsx from 'clsx';

import { RemoveNodeButton } from '../../components/button/RemoveNodeButton';

export const PlateFloatingImage = () => {
  const element = useElement();

  return (
    <div
      className={clsx(
        'slate-ui-floating',
      )}
    >
      <div className="slate-ui-floating__inner slate-ui-floating__inner--single-button">
        <RemoveNodeButton
          element={element}
          className="slate-ui-floating__button"
        />
      </div>
    </div>
  );
};
